import * as angular from 'angular';
import { BehaviorSubject } from 'rxjs';

import { ReportSchedulesListService } from './report-schedules-list.service';

export class ReportSchedulesListController implements angular.IController {
  //bindings
  private report: any;
  private reportRun: any;
  private owner: any;
  private schedules: any;
  private account: any;
  private onSchedulesUpdate: () => void;

  //locals
  private loading: boolean;
  private schedules$: BehaviorSubject<any[]> = new BehaviorSubject(null);
  private displayEmptyMessage$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  static $inject = ['ReportSchedulesListService'];

  constructor(private ReportSchedulesListService: any) {
    this.loading = true;
  }

  $onChanges(changed: angular.IOnChangesObject) {
    if (changed.schedules && changed.schedules.currentValue) {
      this.ReportSchedulesListService.includeScheduleCreatorsAndSubscriptions(this.schedules).then(
        (schedulesWithCreatorsAndSubscriptions) => {
          this.updateSchedulesView(schedulesWithCreatorsAndSubscriptions);
        }
      );
    }
  }

  updateSchedulesView(schedules: any) {
    this.schedules$.next(schedules);
    this.loading = false;
    if (schedules.length === 0) {
      this.displayEmptyMessage$.next(true);
    }
  }

  handleSchedulesUpdate() {
    this.onSchedulesUpdate();
  }
}

export const ReportSchedulesListComponent: angular.IComponentOptions = {
  controller: ReportSchedulesListController,
  controllerAs: 'ctrl',
  bindings: {
    report: '<',
    reportRun: '<',
    owner: '<',
    schedules: '<',
    account: '<',
    onSchedulesUpdate: '&?',
  },
  template: `<ul class="mode-list striped bordered schedules-list-container">
    <li ng-repeat="schedule in (ctrl.schedules$ | async) track by schedule.token">
      <div class="media media-content">
        <div class="row">
          <div class="col-md-10">
            {{schedule.fullFrequencyText}}<br />
            Created by {{schedule.savedCreator.name || schedule.savedCreator.username}}<br />
            <span ng-if="schedule.last_run_at">
              Last run
              <mode-time-ago [date]="schedule.last_run_at">
              </mode-time-ago>
            </span>
            <div ng-if="schedule.fullParamsText !== ''">
              <span class="label label-default" ng-repeat="paramText in schedule.fullParamsText">
                {{paramText}}
              </span>
            </div>
          </div>
          <div class="col-md-2">
            <div
              class="btn btn-sm btn-optional-action"
              schedules-modal
              report="ctrl.report"
              report-run="ctrl.reportRun"
              account="ctrl.account"
              schedule="schedule"
              owner="ctrl.owner"
              on-schedules-update="ctrl.handleSchedulesUpdate()"
            >
            Edit schedule
            </div>
          </div>
        </div>
      </div>
    </li>
    <div class="loading-msg" ng-show="ctrl.loading" >Loading...</div>
    <p class="empty-msg" ng-show="ctrl.displayEmptyMessage$ | async">This report has no schedules.</p>
  </ul>
  `,
};
